const KlarnaBadge = () => (
    <span className="inline-flex items-center justify-center rounded-full bg-[#FFB3C7] px-1.5 py-[3px] text-[9px] font-semibold leading-none text-black [text-box:trim-both_cap_alphabetic]">
        Klarna
    </span>
);

export default KlarnaBadge;
